import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AuthModule } from './components/auth/auth.module';
import { ResourcesModule } from './components/resources/resources.module';
import { SalesModule } from './components/sales/sales.module';
import { SkuModule } from './components/sku/sku.module';
import { QuotationModule } from './components/quotation/quotation.module';
import { ConfigurationModule } from './components/configuration/configuration.module';
import { CustomersModule } from './components/customers/customers.module';
import { ExpensesModule } from './components/expenses/expenses.module';
import { IntegrationModule } from './components/integration/integration.module';
import { IntroModule } from './components/intro/intro.module';
import { ReportsModule } from './components/reports/reports.module';
import { WalletModule } from './components/wallet/wallet.module';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { ButtonModule } from 'primeng/button';
import Material from '@primeng/themes/material';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { DialogModule } from 'primeng/dialog';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ButtonModule,
    AuthModule,
    ResourcesModule,
    SalesModule,
    SkuModule,
    QuotationModule,
    ConfigurationModule,
    CustomersModule,
    ExpensesModule,
    IntegrationModule,
    IntroModule,
    ReportsModule,
    WalletModule,
    DialogModule
  ],
  providers: [provideZoneChangeDetection({ eventCoalescing: true }),
  provideAnimationsAsync(), providePrimeNG({
    theme: {
      preset: Material,
      options: {
        darkModeSelector: false || 'none'
      }
    },
  }), provideHttpClient(withFetch()),],
  bootstrap: [AppComponent]
})
export class AppModule { }
